import { useAuth } from '../provider/OIDCProvider'
import { userHasPermission } from '../../lib/authenticationUtils'
import { AdminUserPermission } from '../../generated/graphql'
import useAppSettings from '../../lib/hooks/useAppSettings'

/**
 * Returns whether the current user may access Civitas Learning AI.
 * Both conditions must be true: the institution must have the
 * PLANNING_AI_ASSISTANT feature flag enabled, and the user must hold the
 * PlanningAiAssistant permission (civitas employees are auto-granted it).
 */
const useAssistantAccess = () => {
  const { user } = useAuth()
  const { adminSetting } = useAppSettings()
  const isEnabled =
    !!adminSetting?.features?.includes('PLANNING_AI_ASSISTANT') &&
    userHasPermission(user, AdminUserPermission.PlanningAiAssistant)
  return { isEnabled }
}

export default useAssistantAccess
